import React, { useEffect, useState, useRef, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as _ from "lodash";

// components
import AnimationLoading from "../../components/Animationloading";
import PaginationHelper from "../../components/PaginationHelper";
import CustomButton from "../../components/CustomButton";
import { errorSwal, warningSwal } from "../../helper/sweetalert";
import { COLOR_APP, USER_KEY } from "../../const";
import { numberFormat } from "../../helper";

// redux
import { useDispatch, useSelector } from "react-redux";
import { addCategorytList } from "../../redux/reducers/categoryReducer";
import { addExchangeRate } from "../../redux/reducers/exchangeRateReducer";
import { addPrinter } from "../../redux/reducers/printerReducer";

// apollo-client
import { ELASTICSEARCH_PRODUCT, GET_EXCHANGE_RATE, GET_PRODUCTS, HIDE_PRODUCT_OUT_OF_STOCK } from "../../apollo/product/query";
import { GET_GEN_CODE_ORDER_GROUP } from "../../apollo/ordergroup/query";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { GET_PRINTERS } from "../../apollo/printer/Query";
import { GET_BRANDS } from "../../apollo/brand/Query";
import { useLazyQuery } from "@apollo/client";

// react-icons
import { GridView, ViewList } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";

// react bootrap
import InputGroup from "react-bootstrap/InputGroup";
import { Button, Offcanvas } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PaginationsV2 from "../../components/PaginationsV2";
import Product from "../sale/product/Product";
import Carts from "../sale/Carts";
import CartsOfferPrice from "./CartsOfferPrice";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import { GET_SHOP } from "../../apollo/shop/Query";
import useWindowDimensions from "../../helper/windowDimensions";
import { MdStar, MdVisibilityOff, MdVisibility } from "react-icons/md";
import { FaCartPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function Offerprice() {
  const { t } = useTranslation();
  const Location = useLocation();
  const saleEditdata = Location;
  const history = useHistory();
  const dispatch = useDispatch();
  const { categoryList } = useSelector((state) => state.category);
  const { printers } = useSelector((state) => state.printer);
  const exchangeRate = useSelector((state) => state.exchange.exchangeRate);
  const { height, width } = useWindowDimensions()

  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [products, setProducts] = useState([]);
  const [originProducts, setOriginProducts] = useState([]);
  const [totalProduct, setTotalProduct] = useState(0);
  const [cartDatas, setCartDatas] = useState([
    {
      id: 1,
      label: "Bill 1",
      data: {
        orders: [],
        orderGroup: {
          amount: 0,
          totalPrice: 0,
          receivedMoney: 0,
          change: 0,
          sumPriceBaht: 0,
          sumPriceUsd: 0,
          currency: "LAK",
          shop: shopId,
          payment: "CASH",
        },
      },
    },
  ]);
  const [activeCart, setActiveCart] = useState("Bill 1");
  const [isTableList, setIsTableList] = useState(true);
  const [brand, setBrand] = useState();
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [selectedPayCurrency, setSelectedPayCurrency] = useState("LAK");
  const [gencodeordergroup, setGenCodeOrderGroup] = useState();
  const containerRef = useRef(null);
  const [filterData, setFilterData] = useState([]);

  const [elasticData, setElasTicData] = useState();
  const [filters, setFilter] = useState({
    // star: false
    hideZero: true
  });
  const [shopDataNew, setShopDataNew] = useState()
  const [isMobileCart, setIsMobileCart] = useState(false)
  const [cateGogoriesData, setCategoriesData] = useState();



  // ເມື່ອເລືອກສິນຄ້າເຂົ້າກະຕ່າແລ້ວ ໃຫ້ scroll ເລື່ອນລົງ auto ຕາມລາຍການສິນຄ້າ
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };

  // ==========> useLazyQuery And useMutation <==========

  const [getProductDatas, { data: productDatas, loading: productLoading }] =
    useLazyQuery(GET_PRODUCTS, { fetchPolicy: "cache-and-network" });

  const [getHideProducts, { data: hideProductsData, loading: hideProductsLoading }] =
    useLazyQuery(HIDE_PRODUCT_OUT_OF_STOCK, { fetchPolicy: "cache-and-network" });

  const [
    loadElasticSearchData,
    { data: elasticSearchData, loading: elasticSearchLoading },
  ] = useLazyQuery(ELASTICSEARCH_PRODUCT, { fetchPolicy: "cache-and-network" });


  const [getPrinterDatas, { data: printerDatas }] = useLazyQuery(GET_PRINTERS, {
    fetchPolicy: "cache-and-network",
  });

  const [getExchangeRate, { data: exchangeRateData }] = useLazyQuery(
    GET_EXCHANGE_RATE,
    { fetchPolicy: "cache-and-network" }
  );

  const [LoadCategory, { data: GetCategoryData }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "cache-and-network" }
  );
  // console.log("GetCategoryData", GetCategoryData)


  const [LoadBrand, { data: GetBrandData }] = useLazyQuery(GET_BRANDS, {
    fetchPolicy: "cache-and-network",
  });

  const [LoadGenCode, { data: GetGenCodeData }] = useLazyQuery(
    GET_GEN_CODE_ORDER_GROUP,
    { fetchPolicy: "network-only" }
  );

  const [loadShop, { data: shopData, loading: loadingShop }] = useLazyQuery(GET_SHOP, { fetchPolicy: "cache-and-network", });


  // ==========> useEffect <==========

  const optionPrice = [
    { id: 0, name: "ລາຄາທີ 1" },
    { id: 1, name: "ລາຄາທີ 2" },
    { id: 2, name: "ລາຄາທີ 3" },
  ];

  useEffect(() => {
    if (shopData) {
      setShopDataNew(shopData)
    }
  }, [shopData])

  useEffect(() => {
    try {
      scrollToBottom();

      // _setNewCartData();
      _loadGenCode();

      //TODO: Get all exchange rate
      if (!exchangeRate) {
        getExchangeRate({
          variables: {
            where: {
              shop: shopId,
            },
          },
        });
      }
      // TODO: Get all category

      if (categoryList.length === 0) {
        LoadCategory({
          variables: {
            // limit: 50,
            where: {
              shop: shopId,
              isDeleted: false,
            },
          },
        });
      }

      // TODO: Get all printer
      if (printers.length === 0) {
        getPrinterDatas({
          variables: {
            where: {
              shop: shopId,
              isDeleted: false,
            },
          },
        });
      }

      _fetchsetShop()
      filterBrand();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }, [shopId]);

  useEffect(() => {
    if (GetCategoryData?.categories?.data) {
      // Create a new array with sorted data
      const result = [...GetCategoryData.categories.data].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      dispatch(addCategorytList(result));
    }

    if (exchangeRateData?.exchangeRate) {
      dispatch(addExchangeRate(exchangeRateData.exchangeRate));
    }

    if (printerDatas?.printers?.data) {
      dispatch(addPrinter(printerDatas?.printers?.data));
    }

    if (productDatas?.products) {
      const productsData = productDatas.products;
      const { data, total } = productsData;

      // Create a new array with data
      const newDataArray = [...data];

      setTotalProduct(total);
      setProducts(newDataArray);
      setOriginProducts(newDataArray);
    }
  }, [
    GetCategoryData?.categories?.data,
    exchangeRateData?.exchangeRate,
    productDatas?.products,
    printerDatas?.printers?.data,
  ]);

  useEffect(() => {
    if (GetGenCodeData) {
      const number = GetGenCodeData?.orderGroups?.total + 1;
      let _genBarCode = number.toString().padStart(4, "0");
      setGenCodeOrderGroup(_genBarCode);
    }
  }, [GetGenCodeData]);

  useEffect(() => {
    if (GetBrandData?.brands?.data?.length > 0) {
      const dataCopy = [...GetBrandData.brands.data]; // Create a shallow copy of the array
      const result = dataCopy.sort((a, b) => a?.name?.localeCompare(b?.name));
      setBrand(result);
    }
  }, [GetBrandData]);

  useEffect(() => {
    updateOrderGroup();
  }, [JSON.stringify(cartDatas), selectedPayCurrency]);

  useEffect(() => {
    if (filters?.category) {
      filterBrand();
    }

    _filter();
  }, [
    filters?.name,
    filters?.category,
    filters?.brand,
    filters?.star,
    filters?.hideZero,
    selectedPrice,
    _skip,
    // searchStar,
  ]);

  useEffect(() => {
    elasticSearchProduct();
  }, [elasticData]);

  useEffect(() => {
    if (elasticSearchData) {
      setFilterData(elasticSearchData?.getProductElastisSearch?.data);
    }
  }, [elasticSearchData]);


  useEffect(() => {
    if (saleEditdata.state?.isEdited) {
      const _offerPriceGroupData = saleEditdata.state?.state;

      // console.log("_offerPriceGroupData--------->", _offerPriceGroupData);

      const cartItems =
        _offerPriceGroupData?.orders ?? _offerPriceGroupData?.offerprices;
      const updatedProduct = _.cloneDeep(productDatas?.products?.data); // Make a deep copy of the original array

      // console.log("cartItems------------>", cartItems);

      const _newOrders = cartItems?.map((order) => {
        // console.log("cartItems order------------>", order);

        // TODO: Update product quantity
        const _pIndex = _.findIndex(updatedProduct, {
          id: order?.stock?.id,
        }); // Find the index of the object

        // console.log("_pIndex return------>");
        // console.log("_pIndex return------>", _pIndex);

        if (_pIndex >= 0) {
          updatedProduct[_pIndex] = {
            ...updatedProduct[_pIndex],
            amount: saleEditdata.state?.isFromSale
              ? parseInt(updatedProduct[_pIndex]?.amount)
              : parseInt(updatedProduct[_pIndex]?.amount) -
              parseInt(order?.amount),
          };
          // setProducts(updatedProduct);
          setOriginProducts(updatedProduct);
        }

        return {
          id: order?.id,
          amount: order?.amount,
          // totalAmount:
          //   updatedProduct[_pIndex]?.amount ??
          //   updatedProduct[_pIndex]?.originAmount,
          price: order?.price,
          // priceOptions: updatedProduct[_pIndex]?.priceOptions,
          totalPrice: order?.totalPrice,
          shop: _offerPriceGroupData?.shop?.id,
          product: order?.stock?.id,
          productName: order?.productName,
          // brand: updatedProduct[_pIndex]?.brand?.name,
          // category: updatedProduct[_pIndex]?.category?.name,
          // unit: updatedProduct[_pIndex]?.unit?.name,
          currency: order?.currency ? order?.currency : "LAK",
        };
      });

      // console.log("_newOrders-------->", _newOrders);

      const _newCartData = {
        id: 1,
        label: "Bill 1",
        data: {
          orders: _newOrders,
          orderGroup: {
            amount: _offerPriceGroupData?.amount,
            totalPrice: _offerPriceGroupData?.totalPrice,
            sumPrice: _offerPriceGroupData?.sumPrice,
            receivedMoney: 0,
            change: 0,
            sumPriceBaht: _offerPriceGroupData?.sumPriceBaht,
            sumPriceUsd: _offerPriceGroupData?.sumPriceUsd,
            currency: "LAK",
            shop: _offerPriceGroupData?.shop?.id,
            payment: "CASH",
          },
        },
      };
      return setCartDatas([_newCartData]);
    }
  }, [saleEditdata.state?.isEdited]);

  // fetch shop data
  const _fetchsetShop = () => {
    loadShop({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };


  const elasticSearchProduct = async () => {
    try {
      let _where = { shop: shopId, isDeleted: false };


      if (!elasticData) return;
      if (elasticData) _where = { ..._where, name: elasticData };
      else _where = { ..._where };

      loadElasticSearchData({
        variables: {
          limit: 5,
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // ==========> fuctions <==========

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
    };
    if (filters?.category) {
      _where = { ..._where, category: filters?.category };
    }
    // TODO: Get all brand
    LoadBrand({
      variables: {
        // limit: 50,
        where: _where,
      },
    });
  };

  const _filter = async () => {
    try {
      let _where = { shop: shopId, isDeleted: false };

      if (!_.isEmpty(cateGogoriesData) && cateGogoriesData !== "ALL") {
        _where = {
          ..._where,
          category: cateGogoriesData?.id,
          categoryName: cateGogoriesData?.name,
        };
      }
      // if (filters?.category)
      //   _where = { ..._where, category: filters?.category };
      if (filters?.brand) _where = { ..._where, brand: filters?.brand };
      if (filters?.name) _where = { ..._where, name: filters?.name };
      if (filters?.star) _where = { ..._where, star: true };
      else _where = { ..._where };
      // else _where = {..._where, star:false}

      if (filters?.hideZero) {
        const result = await getHideProducts({
          variables: {
            skip: (_skip - 1) * _limit,
            limit: _limit,
            orderBy: "createdAt_DESC",
            where: _where,
          },
        });
        const list = result?.data?.hideProductsOutOfStock?.data || [];
        const total = result?.data?.hideProductsOutOfStock?.total || 0;
        setProducts(list);
        setOriginProducts(list);
        setTotalProduct(total);
      } else {
        getProductDatas({
          variables: {
            skip: (_skip - 1) * _limit,
            limit: _limit,
            orderBy: "createdAt_DESC",
            where: _where,
          },
        });
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const _loadGenCode = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await LoadGenCode({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  const _setNewCartData = async () => {
    const shopId = (await JSON.parse(localStorage.getItem("SHOP_DATA")))?.id;
    const number = parseInt(gencodeordergroup);
    let _genBarCode = number.toString().padStart(4, "0"); // Pad with leading zeros

    setCartDatas([
      {
        id: 1,
        label: "Bill 1",
        data: {
          orders: [],
          orderGroup: {
            // code: _genBarCode,
            amount: 0,
            totalPrice: 0,
            receivedMoney: 0,
            change: 0,
            sumPriceBaht: 0,
            sumPriceUsd: 0,
            currency: "LAK",
            shop: shopId,
            payment: "CASH",
          },
        },
      },
    ]);
  };

  // Push to an array
  const addOrder = ({ product, productPrice }) => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;

    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    // TODO: Check product amount
    // if (product?.amount <= 0) return;

    let amount = 1;
    let totalPrice = 0;
    totalPrice =
      productPrice > 0
        ? productPrice
        : product?.priceOptions.length > 0
          ? product?.priceOptions[parseInt(selectedPrice)]?.price
          : product?.price;
    // TODO: Check currency and set total price

    // TODO: Set new order
    const _newOrder = {
      amount,
      totalAmount: product?.amount ?? product?.originAmount,
      originPrice: product?.price,
      price:
        productPrice > 0
          ? productPrice
          : product?.priceOptions.length > 0
            ? product?.priceOptions[parseInt(selectedPrice)]?.price
            : product?.price,
      priceOptions: product?.priceOptions,
      totalPrice,
      shop: shopId,
      product: product?.id,
      productName: product?.name,
      brand: product?.brand?.name,
      category: product?.category?.name,
      unit: product?.unitId?.name ?? product?.unit,
      currency: product?.currency ? product?.currency : "LAK",
      survivalId: product?.survivalId,
    };

    // TODO: Set new cart datas
    const _newCartDatas = cartDatas?.map((cart) => {
      if (cart?.label === activeCart) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: { orders: [...orders, _newOrder], orderGroup },
        };
      }
      return cart;
    });

    // TODO: Set cartDatas state into cart datas
    setCartDatas(_newCartDatas);

    // TODO: Update product quantity
    const updatedOriginProduct = [...originProducts]; // Make a deep copy of the original Product
    const _originProductIndex = _.findIndex(updatedOriginProduct, {
      id: product?.id,
    }); // Find the index of the object
    updatedOriginProduct[_originProductIndex] = {
      ...updatedOriginProduct[_originProductIndex],
      amount:
        parseInt(updatedOriginProduct[_originProductIndex]?.amount) -
        parseInt(amount),
    };
    setOriginProducts(updatedOriginProduct);
    scrollToBottom();
    return;
  };

  // Update object within an array
  const updateOrder = ({ product, productId, isAdded, changeValue }) => {
    // console.log("add amount 1---->")

    const _originProductIndex = _.findIndex(originProducts, { id: productId });
    // console.log("add amount---->")

    // if (originProducts[_originProductIndex]?.amount <= 0 && isAdded)
    //   return warningSwal(
    //     `ສິນຄ້າ  ${originProducts[_originProductIndex]?.name} ໝົດສະຕອັກ`
    //   );

    // if (changeValue < 0) return;
    // TODO: Set new orders
    const _newOrders = (cart) =>
      cart?.data?.orders?.map((order) => {
        let amount = order?.amount;

        // console.log("add amount 2---->")

        if (order.product === productId) {
          // console.log("add amount 2.1---->")

          let totalPrice = order?.totalPrice ?? 0;
          let totalPriceBaht = order?.totalPriceBaht ?? 0;
          let totalPriceUsd = order?.totalPriceUsd ?? 0;

          // TODO: Check order amount and product amount
          const updatedOriginProduct = [...originProducts]; // Make a deep copy of

          if (changeValue > 0 || !Number.isFinite(changeValue)) {
            // console.log("add amount 3---->")

            amount = !Number.isFinite(changeValue) ? 0 : changeValue;

            // console.log("changeValue 3---->",changeValue)
            // console.log("amount 3---->",amount)

            updatedOriginProduct[_originProductIndex] = {
              ...updatedOriginProduct[_originProductIndex],
              amount:
                parseInt(updatedOriginProduct[_originProductIndex]?.amount) +
                parseInt(
                  order?.amount -
                  (!Number.isFinite(changeValue) ? 0 : changeValue)
                ),
            };
          } else if (isAdded) {
            // console.log("minus amount---->")
            amount++;
            updatedOriginProduct[_originProductIndex] = {
              ...updatedOriginProduct[_originProductIndex],
              amount:
                parseInt(updatedOriginProduct[_originProductIndex]?.amount) + 1,
            };
          } else if (!isAdded) {
            // console.log("add amount---->")
            amount--;
            updatedOriginProduct[_originProductIndex] = {
              ...updatedOriginProduct[_originProductIndex],
              amount:
                parseInt(updatedOriginProduct[_originProductIndex]?.amount) - 1,
            };
          }

          // update product and orgin product
          setOriginProducts(updatedOriginProduct);

          //ກວດຈຳນວນສັ່ງຊື້ ມີ ຫຼື ບໍ່
          //ຖ້າບໍ່ມີ ໃຫ້ລາຄາເປັນສູນ
          //ຖ້າມີໃຫ້ ເອົາຈຳນວນ ຄູນ ໃຫ້ລາຄາ

          // TODO: Check currency and calculate total price
          totalPrice = amount * order?.price;
          if (order?.currency === "LAK" || order?.currency === "ກີບ")
            totalPrice = amount * order?.price;
          if (order?.currency === "BAHT" || order?.currency === "ບາດ")
            totalPrice = amount * order?.price;
          if (order?.currency === "USD" || order?.currency === "ໂດລາ")
            totalPrice = amount * order?.price;

          return {
            ...order,
            ...{ amount, totalPrice, totalPriceBaht, totalPriceUsd },
          };
        }
        return order;
      });

    // TODO: Set update cart datas
    let _updateCartDatas = cartDatas?.map((cart) => {
      if (cart?.label === activeCart) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: {
            orderGroup,
            orders: _newOrders(cart),
          },
        };
      }
      return cart;
    });
    // console.log("======", { _updateCartDatas });
    setCartDatas(_updateCartDatas);
  };

  // TODO: Update order group
  const updateOrderGroup = async () => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;
    const { orders, orderGroup } = selectedCart?.data;
    let totalPrice = 0;
    let sumPriceBaht = 0;
    let sumPriceUsd = 0;
    let amount = 0;
    let sumPrice = 0; // price must pay

    // TODO: Sum amount and price and calculate total price to kip
    orders?.map((order) => {
      amount = amount + order?.amount;
      const price = order.price * order.amount;
      if (order?.currency === "LAK" || order?.currency === "ກີບ") {
        totalPrice = totalPrice + price;
        sumPrice = sumPrice + price;
      }
      if (order?.currency === "BAHT" || order?.currency === "ບາດ") {
        sumPriceBaht = sumPriceBaht + price;
        sumPrice = sumPrice + price * exchangeRate?.baht;
      }
      if (order?.currency === "USD" || order?.currency === "ໂດລາ") {
        sumPriceUsd = sumPriceUsd + price;
        sumPrice = sumPrice + price * exchangeRate?.usd;
      }
    });

    if (["BAHT", "ບາດ"].includes(selectedPayCurrency)) {
      sumPrice = sumPrice / exchangeRate?.baht;
    } else if (["USD", "ໂດລາ"].includes(selectedPayCurrency)) {
      sumPrice = sumPrice / exchangeRate?.usd;
    } else {
      sumPrice = sumPrice;
    }

    const _updatedOrderGroup = {
      ...orderGroup,
      amount,
      totalPrice,
      sumPriceBaht,
      sumPriceUsd,
      sumPrice,
    };
    // return _updatedOrderGroup;

    setCartDatas((preCarts) =>
      preCarts.map((cart) => {
        if (cart.label === activeCart) {
          return {
            ...cart,
            data: { orders, orderGroup: _updatedOrderGroup },
          };
        }
        return cart;
      })
    );
  };

  // Clear order from cart
  const onClearOrder = (order) => {
    const prevState = cartDatas.map((cart) => {
      return {
        ...cart,
        data: {
          orders: cart?.data?.orders.filter(
            (_order) =>
              _order.product !== order?.product || cart?.label !== activeCart
          ),
        },
      };
    });
    setCartDatas(prevState);

    // TODO: Update product uantity
    const _originProductIndex = _.findIndex(originProducts, {
      id: order?.product,
    });
    const updateOriginProduct = [...originProducts];

    updateOriginProduct[_originProductIndex] = {
      ...updateOriginProduct[_originProductIndex],
      amount: originProducts[_originProductIndex].amount + order?.amount,
    };
    // setProducts(updateProduct);
    setOriginProducts(updateOriginProduct);
    return;
    // }
  };

  const handleKeyNameProduct = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setFilter({
        ...filters,
        name: e?.target?.value,
      });

      setElasTicData();
    }
  };

  const handleSearchData = (e) => {
    const value = e.target.value.trim();
    if (value) {
      setElasTicData(value)
    }
  }

  const parentDivRef = useRef(null)

  useEffect(() => {
    // Event listener for clicks outside the parent div
    const handleClickOutside = (event) => {
      if (parentDivRef.current && !parentDivRef.current.contains(event.target)) {
        setElasTicData();
      }
    };

    // Attach the event listener to the document body
    document.body.addEventListener("click", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);



  return (
    <>
      {" "}
      <BreadCrumbComponent
        goback={history.goBack}
        txtSecond={`ອອກໃບສະເໜີລາຄາ`}
      />
      <div className="d-flex gap-2 ">
        {/* Cart sale */}
        {width > 700 && <CartsOfferPrice
          products={products}
          setProducts={setProducts}
          cartDatas={cartDatas}
          setCartDatas={setCartDatas}
          activeCart={activeCart}
          setActiveCart={setActiveCart}
          updateOrder={updateOrder}
          onClearOrder={onClearOrder}
          fetchProductData={_filter}
          printer={printers}
          originProducts={originProducts}
          setOriginProducts={setOriginProducts}
          selectedPayCurrency={selectedPayCurrency}
          setSelectedPayCurrency={setSelectedPayCurrency}
          gencodeordergroup={gencodeordergroup}
          _loadGenCode={_loadGenCode}
          saleEditdata={saleEditdata}
          containerRef={containerRef}
          productLoading={productLoading}
          addOrder={addOrder}
          shopData={shopDataNew}
          setIsMobileCart={setIsMobileCart}

        />}
        {/* product list Select */}
        <div style={{ width: "100%" }}>
          <div className="d-flex gap-4 px-4 mb-2">
            {width < 700 && <InputGroup className="mr-2">
              <InputGroup.Text
                style={{
                  backgroundColor: "#FFFFFF",
                  // border: 'none'
                }}
              >
                <SearchIcon sx={{ color: "#6B7280" }} />
              </InputGroup.Text>
              <Form.Control
                placeholder="ຄົ້ນຫາສິນຄ້າ..."
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                onKeyDown={(e) => handleKeyNameProduct(e)}
                onChange={(e) => {
                  let _value = e?.target?.value;
                  if (_value === "") {
                    setFilterData([])
                  }
                  setElasTicData(_value)
                }}
                style={{
                  borderLeft: "none",
                  // border: 'none'
                }}
              />
            </InputGroup>}
            {width < 700 && <div
              style={{
                border: "none",
                height: 40,
                marginLeft: width > 400 ? '2em' : 5,
                padding: 5,
                position: 'relative',
                cursor: 'pointer'
              }}
              onClick={() => setIsMobileCart(true)}
            >
              <FaCartPlus style={{ fontSize: 28 }} />

              {!_.isEmpty(cartDatas[0]?.data?.orders) && <span
                style={{
                  position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 10, top: -7,
                  right: -10, width: 20, borderRadius: '40em', height: 20, background: 'red', color: 'white'
                }}>{cartDatas[0]?.data?.orders?.length ?? 0}</span>}
            </div>}
          </div>
          {/* navbar */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: 5, gap: 5,
              position: 'relative'
            }}
          >
            {width > 700 && <InputGroup className="mr-2">
              <InputGroup.Text
                style={{
                  backgroundColor: "#FFFFFF",
                  // border: 'none'
                }}
              >
                <SearchIcon sx={{ color: "#6B7280" }} />
              </InputGroup.Text>
              <Form.Control
                placeholder="ຄົ້ນຫາສິນຄ້າ..."
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                onKeyDown={(e) => handleKeyNameProduct(e)}
                onChange={(e) => {
                  let _value = e?.target?.value;
                  if (_value === "") {
                    setFilterData([])
                  }
                  setElasTicData(_value)
                }}
                style={{
                  borderLeft: "none",
                  // border: 'none'
                }}
              />
            </InputGroup>}

            {elasticData?.length >= 1 && (
              <div
                ref={parentDivRef}
                style={{
                  position: "absolute",
                  zIndex: 999,
                  left: "1.5em",
                  top: "2.5em",
                  background: "#ffffff",
                  width: "80%",
                  borderRadius: 3,
                  padding: 10,
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                }}
              >
                <ul>
                  {filterData.map((data, index) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          setFilter({
                            ...filters,
                            name: data?.name,
                          });
                          setElasTicData();
                        }}
                        className="menu-search-data"
                      >
                        {data?.name}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <Form.Select
              className="w-50"
              onChange={(e) => {
                const getId = e?.target?.value;
                setFilter({
                  ...filters,
                  category: getId,
                });

                const selectedCategory = categoryList.find(
                  (data) => data.id === getId
                );
                if (selectedCategory) {
                  const categoryData = {
                    id: selectedCategory.id,
                    name: selectedCategory.name,
                  };
                  setCategoriesData(categoryData);
                } else {
                  setCategoriesData("All");
                }

              }}
            >
              <option value="">ປະເພດ</option>
              {categoryList?.map((categorys, cIndex) => (
                <option key={cIndex} value={categorys?.id}>
                  {categorys?.name}
                </option>
              ))}
            </Form.Select>
            {width > 700 && <Form.Select
              className="w-50"
              onChange={(e) => {
                setFilter({
                  ...filters,
                  brand: e?.target?.value,
                });

              }}
            >
              <option value="">ເເບຣນທັງໜົດ</option>
              {brand?.map((brands, index) => (
                <option key={index} value={brands?.id}>
                  {brands?.name}
                </option>
              ))}
            </Form.Select>}
            <CustomButton
              width={"60%"}
              borderRadius={8}
              background={filters?.star ? "#3C169B" : "white"}
              color={filters?.star ? "white" : "#6B7280"}
              border={filters?.star ? "" : " 1px solid #D1D5DB"}
              // margin={"0px 0px 10px 25px"}
              height={40}
              onClick={() => {
                setFilter({
                  ...filters,
                  star: !filters?.star,
                });

              }}
              title={"ສິນຄ້າຂາຍດີ"}
            />
            <CustomButton
              width={"60%"}
              borderRadius={8}
              background={filters?.hideZero ? "white" : COLOR_APP}
              color={filters?.hideZero ? "#6B7280" : "white"}
              border={filters?.hideZero ? "1px solid #D1D5DB" : ""}
              height={40}
              onClick={() => {
                setFilter({
                  ...filters,
                  hideZero: !filters?.hideZero,
                });
              }}
              title={""}
              icon={filters?.hideZero ? <MdVisibility /> : <MdVisibilityOff />}
            />
            <Form.Select
              style={{
                backgroundColor: "#fff",
                color: "#6B7280",
                cursor: "pointer",
                margin: "0px 3px",
                width: 150,
                height: 40,
              }}
              onChange={(e) => {
                setSelectedPrice(e.target.value);

              }}
              value={selectedPrice}>
              {optionPrice?.map(({ id, name }) => (
                <option key={id} value={id.toString()}>
                  {name}
                </option>
              ))}
            </Form.Select>
            {/* <Button
              onClick={() => setIsTableList(!isTableList)}
              style={{
                backgroundColor: "#6B7280",
                border: "none",
                margin: "0px 0px 0px 3px",
                height: 40,
              }}>
              {!isTableList ? (
                <ViewList style={{ color: "#fff" }} />
              ) : (
                <GridView style={{ color: "#fff" }} />
              )}
            </Button> */}
          </div>

          <Product
            _skip={_skip}
            _limit={_limit}
            products={products}
            activeCart={activeCart}
            cartDatas={cartDatas}
            updateOrder={updateOrder}
            addOrder={addOrder}
            isTableList={isTableList}
            setCartDatas={setCartDatas}
            selectedPrice={selectedPrice}
            originProducts={originProducts}
            optionPrice={optionPrice}
            productLoading={productLoading}
            shopData={shopDataNew}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ marginTop: ".8em" }}>
              {Pagination_helper(totalProduct, "", ``)}
            </div>
          </div>
        </div>


      </div >

      <Offcanvas show={isMobileCart} onHide={() => setIsMobileCart(false)} placement="bottom" style={{ height: 640 }}>
        <Offcanvas.Header closeButton style={{ borderBottom: '1px solid #fefefe' }}>
          <Offcanvas.Title>ກະຕ່າສິນຄ້າ</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body >
          <CartsOfferPrice
            products={products}
            setProducts={setProducts}
            cartDatas={cartDatas}
            setCartDatas={setCartDatas}
            activeCart={activeCart}
            setActiveCart={setActiveCart}
            updateOrder={updateOrder}
            onClearOrder={onClearOrder}
            fetchProductData={_filter}
            printer={printers}
            originProducts={originProducts}
            setOriginProducts={setOriginProducts}
            selectedPayCurrency={selectedPayCurrency}
            setSelectedPayCurrency={setSelectedPayCurrency}
            gencodeordergroup={gencodeordergroup}
            _loadGenCode={_loadGenCode}
            saleEditdata={saleEditdata}
            containerRef={containerRef}
            productLoading={productLoading}
            addOrder={addOrder}
            shopData={shopDataNew}
            setIsMobileCart={setIsMobileCart}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Offerprice;
